var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.391 508.391",
    style: {
      enableBackground: "new 0 0 508.391 508.391"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2E3E5"
    },
    points: "255.184,275.97 37.11,239.941 507.391,23.763 279.836,482.667  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCCCCC"
    },
    points: "226.739,275.97 8.665,239.941 478.947,23.763 251.391,482.667  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E3E5"
    },
    d: "M430.591,40.83c0,1.896-1.896,3.793-4.741,5.689c-24.652,13.274-50.252,23.704-76.8,32.237 c-31.289,13.274-63.526,26.548-92.919,43.615c-30.341,17.067-57.837,28.444-90.074,40.77 c-33.185,12.326-61.63,35.081-94.815,46.459c-1.896,0.948-3.793,0.948-5.689,0L8.665,239.941l197.215,30.341l0.948,3.793 c0.948,0,1.896-0.948,3.793-0.948c7.585,0,11.378,7.585,9.481,13.274c10.43,15.17,7.585,35.081,8.533,53.096 c0.948,32.237,8.533,63.526,17.067,93.867L441.021,37.037C438.176,37.985,434.384,39.881,430.591,40.83"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B6"
    },
    d: "M251.391,492.148c-0.948,0-0.948,0-1.896,0c-3.793-0.948-7.585-3.793-7.585-8.533l-23.704-199.111 L6.769,249.422c-3.793-0.948-7.585-3.793-7.585-8.533c-0.948-3.793,1.896-8.533,5.689-9.481L475.154,15.23 c3.793-1.896,7.585-0.948,10.43,1.896c2.844,2.844,3.793,7.585,1.896,10.43L259.924,486.459 C258.976,490.252,255.184,492.148,251.391,492.148z M40.902,235.2l187.733,31.289c3.793,0.948,7.585,3.793,7.585,8.533 L257.08,450.43L459.036,43.674L40.902,235.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigation);
export default __webpack_public_path__ + "static/media/navigation.2b0a61e6e09cb3c341a36fedd11150e1.svg";
export { ForwardRef as ReactComponent };